export const LOAD_MODES = [
  { id: 'replace', label: 'Replace', description: 'Replace the fetched periods. Remove rows no longer returned; keep other periods.' },
  { id: 'upsert', label: 'Upsert', description: 'Update matching rows and add new ones. Keep other rows and periods.' },
  { id: 'incremental', label: 'Incremental', description: 'Add new rows only. Existing rows keep their current values.' },
  { id: 'total_replace', label: 'Total Replace', description: 'Replace all stream data, only after the entire extraction succeeds.' },
];

export const dateKey = date => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');

function keyDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
  const [year, month, day] = value.split('-').map(Number);
  const result = new Date(year, month - 1, day);
  return dateKey(result) === value ? result : null;
}

export function normalizedBackfillRange(range, reachType, today = new Date()) {
  const from = keyDate(range.from);
  const to = keyDate(range.ongoing ? dateKey(today) : range.to);
  if (!from || !to || from > to || from > today || to > today) return null;
  let start = from, end = to;
  if (reachType === 'monthly') {
    start = new Date(from.getFullYear(), from.getMonth(), 1);
    end = new Date(to.getFullYear(), to.getMonth() + 1, 0);
    if (end > today) end = to;
  } else if (reachType === 'weekly') {
    start = new Date(from.getFullYear(), from.getMonth(), from.getDate() - (from.getDay() + 6) % 7);
    end = new Date(to.getFullYear(), to.getMonth(), to.getDate() + 6 - (to.getDay() + 6) % 7);
    if (end > today) end = to;
  } else return null;
  return start <= end ? { from: dateKey(start), to: dateKey(end) } : null;
}

export const streamNameForAccount = (base, label) => `${base.trim()} (${label})`;
export const selectMatchingAccounts = (selected, matchingIds) => [...new Set([...selected, ...matchingIds])];
export const validLookbackDays = value => /^\d+$/.test(String(value)) && Number(value) >= 1 && Number(value) <= 365;

// Keep the simplified creation choices in sync with the persisted "basic" extraction profile.
export const setupFieldChoices = (levels, kpis) => ({
  levels: levels.filter(id => ['account', 'campaign'].includes(id)),
  kpis: kpis.filter(id => !['frequency', 'cpm', 'cpc', 'ctr'].includes(id)),
});

export function advancedValidity({ cadence, time, timezone, weekdays, monthDay, loadMode, totalReplaceConfirmed, lookbackDays = 10 }) {
  return ['daily', 'weekly', 'monthly'].includes(cadence) && /^([01]\d|2[0-3]):[0-5]\d$/.test(time)
    && Boolean(timezone) && (cadence !== 'weekly' || weekdays.length > 0)
    && (cadence !== 'monthly' || (Number(monthDay) >= 1 && Number(monthDay) <= 28))
    && LOAD_MODES.some(mode => mode.id === loadMode)
    && (loadMode === 'total_replace' || validLookbackDays(lookbackDays))
    && (loadMode !== 'total_replace' || totalReplaceConfirmed === true);
}
